export default {
  layout: {
    "rows": [
      {
        "fields": [ { "name": "cart.name" } ]
      },

      {
        "fields": [ { "name": "cart.sharedWith" } ]
      },

      {
        "fields": [ { "name": "cart.sharedWithGroups" } ]
      },

      {
        "fields": [ { "name": "cart.description" } ]
      },

      {
        "fields": [ { "name": "cart.specimenLabels" } ]
      },

      {
        "fields": [ { "name": "cart.sendDigestNotifs" } ]
      }
    ]
  }
}
